(function () {
  var bar = document.getElementById('fitz-announcement-bar');
  if (!bar) return;

  var shippingEl = document.getElementById('fitz-announcement-shipping');
  var slides = bar.querySelectorAll('.fitz-announcement-bar__slide');
  var threshold = parseFloat(bar.dataset.freeShippingThreshold || '75');
  var rotateIndex = 0;
  var rotateTimer = null;

  function renderShippingMessage(cart) {
    var remainingCents = threshold * 100 - cart.total_price;
    if (cart.item_count === 0) {
      shippingEl.innerHTML =
        'Free shipping for orders over <span class="fitz-announcement-bar__highlight">$' + threshold + '</span>';
    } else if (remainingCents > 0) {
      var remaining = (remainingCents / 100).toFixed(0);
      shippingEl.innerHTML =
        'Only <span class="fitz-announcement-bar__highlight">$' + remaining + '</span> away from free shipping!';
    } else {
      shippingEl.textContent = "Congratulations! You've got free shipping";
    }
  }

  function fetchCart() {
    fetch(window.Shopify.routes.root + 'cart.js')
      .then(function (res) {
        return res.json();
      })
      .then(renderShippingMessage)
      .catch(function () {});
  }

  function rotate() {
    slides[rotateIndex].classList.remove('is-active');
    rotateIndex = (rotateIndex + 1) % slides.length;
    slides[rotateIndex].classList.add('is-active');
  }

  function setBarHeight() {
    document.documentElement.style.setProperty('--fitz-announcement-bar-height', bar.offsetHeight + 'px');
  }

  fetchCart();
  setBarHeight();
  window.addEventListener('resize', setBarHeight);

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, fetchCart);
  }

  rotateTimer = setInterval(rotate, 4500);
})();
